export default "__VITE_ASSET__Cnu5rEnt__"